var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/home.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-44f78b96!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/home.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Home.vue
// module id = 631
// module chunks = 1